import i18next from 'i18next';

export type IntlFormatter = Parameters<NonNullable<typeof i18next["services"]["formatter"]>["add"]>;

export const upperCaseFormatter: IntlFormatter = ['uppercase', (value: any, lng: string | undefined, options: any) => {
    return (value as string).toUpperCase();
}];

export const lowerCaseFormatter: IntlFormatter = ['lowercase', (value: any, lng: string | undefined, options: any) => {
    return (value as string).toLowerCase();
}];